export default __webpack_public_path__ + "static/EnhanceAlerts-abfe7440ba9771255d5207c4471a37f9.png";